import React, { useContext } from 'react'
import { apiContext } from 'services/ApiContext'
import { useUpgradePremiumMembership } from 'services/projects'
import UpgradePremiumButton from 'components/LayoutComponents/TopBar/UpgradePremiumButton'
import { Button } from 'antd'
import { useTranslate } from 'services/utils'

import './style.scss'
import PaywallModal from './Modal'
import BuyAdditionalPackageButton from './BuyAdditionalPackageButton'
import BackToOverviewButton from './BackToOverviewButton'

const Paywall = ({ sampleImage, children, onClose = () => null }) => {
  const { user, project } = useContext(apiContext)
  const [upgradeToPremiumMembership, { loading }] = useUpgradePremiumMembership()

  const projectId = project.id
  const hasGroup = !!user.group
  const isOwner = hasGroup && user.userId === user.group.owner.userId

  // check if group has a package with a valid contingent, if not user has to buy extra contingents
  const hasRemainingContigent =
    hasGroup &&
    user.group.packages.filter((p) => !p.expired && p.contingents > p.appliedContingents.length)
      .length > 0

  const translate = useTranslate()

  const sample = sampleImage ? (
    <div className="sample-image" style={{ backgroundImage: `url(${sampleImage})` }} />
  ) : null

  if (!hasGroup) {
    return (
      <PaywallModal
        title={translate('paywall.premiumRequired')}
        description={translate('paywall.premiumRequired.description')}
        action={<UpgradePremiumButton />}
        onClose={onClose}
      >
        {sample || children}
      </PaywallModal>
    )
  }

  let action
  if (!isOwner) {
    action = <p>{translate('paywall.contactOwner')}</p>
  } else if (hasRemainingContigent) {
    action = (
      <Button
        className="ant-btn-primary"
        disabled={loading}
        onClick={(e) => {
          e.stopPropagation()
          upgradeToPremiumMembership(projectId).then(onClose)
        }}
      >
        {translate('paywall.upgradeProject')}
      </Button>
    )
  } else {
    action = (
      <>
        <p>{translate('paywall.noContingents')}</p>
        <div>
          <BuyAdditionalPackageButton />
          <BackToOverviewButton />
        </div>
      </>
    )
  }

  return (
    <PaywallModal
      title={translate('paywall.modal.title')}
      description={translate('paywall.modal.description')}
      action={action}
      onClose={onClose}
    >
      {sample || children}
    </PaywallModal>
  )
}

export default Paywall
